export default {
  STATUS_DRAFT: "Brouillon",
  STATUS_SUBMITTED: "Soumise",
  STATUS_ACCEPTED: "Acceptée",
  STATUS_REJECTED: "Rejetée",
  STATUS_CANCELED: "Annulée",
  DELETE_ESTABLISHMENT_TRANSFER: "Supprimer le transfert d'établissement",
  ADD_ITEMS_FIRST: "Ajoutez au moins un article de transfert avant de soumettre.",
  ACCEPT: "Accepter",
  REJECT: "Rejeter",
  SUBMITTED_BY: "Soumis par",
  SUBMITTED_AT: "Soumis le",
  ACCEPTED_BY: "Accepté par",
  ACCEPTED_AT: "Accepté le",
  TRANSFER_DATE: "Date du transfert",
  CHANGE_ACCEPTED_DATE: "Changer la date de facturation",
  CHANGE_ACCEPTED_DATE_HELP:
    "Cette date détermine la semaine du rapport hebdomadaire dans laquelle le transfert est comptabilisé.",
  ACCEPTED_DATE: "Date de comptabilisation",
  ACCEPTED_DATE_UPDATED: "Date de facturation mise à jour",
  CANCEL_ACCEPTED_TRANSFER: "Annuler ce transfert accepté ?",
  CANCEL_ACCEPTED_TRANSFER_HELP:
    "Le transfert sera retiré du rapport hebdomadaire des deux établissements, y compris d'un rapport déjà validé.",
};
